/**
 * 婚丧假
 */
import request from "@/utils/request";

// 列表
export function adeLeaveRecordPage(data) {
  return request({
    url: `/ade/adeLeaveRecordPage`,
    method: "post",
    data
  });
}
// 上传
export function adeUploadImgUrl(data) {
  return request({
    url: `/ade/uploadImgUrl`,
    method: "post",
    data
  });
}
// 复核
export function adeAuditImgUrl(data) {
  return request({
    url: `/ade/auditImgUrl`,
    method: "post",
    data
  });
}
// 冒泡
export function getAdeLeaveRecordNum() {
  return request({
    url: `/ade/getAdeLeaveRecordNum`,
    method: "get",
  });
}
